import BasicModel from '../basic/BasicModel'
export default {
  selectByAccountNumber(vm, params, listener) {
    let action = 'sxbUser/selectByAccountNumber.action'
    BasicModel.get(vm, action, params, listener)
  }
}
